import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CRMDevelopmentIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "CRMDevelopment",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M14.27 21.31a1.145 1.145 0 0 1-1.11-1.44l2.46-9.16c.16-.61.79-.97 1.4-.81s.97.79.81 1.4l-2.46 9.16c-.14.51-.6.85-1.1.85M21.29 19.14c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l1.55-1.55-1.55-1.55a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l2.36 2.36a1.16 1.16 0 0 1 0 1.62l-2.36 2.36c-.22.22-.52.33-.81.33M9.86 19c-.29 0-.58-.11-.81-.33l-2.36-2.36a1.14 1.14 0 0 1 0-1.62l2.36-2.36a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62L9.12 15.5l1.55 1.55A1.14 1.14 0 0 1 9.86 19"
    }), /*#__PURE__*/_jsx("path", {
      d: "M25.86 29.29H5.29c-1.89 0-3.43-1.54-3.43-3.43V5.29c0-1.89 1.54-3.43 3.43-3.43h20.57c1.89 0 3.43 1.54 3.43 3.43v20.57c0 1.89-1.54 3.43-3.43 3.43M5.29 4.14c-.63 0-1.14.51-1.14 1.14v20.57c0 .63.51 1.14 1.14 1.14h20.57c.63 0 1.14-.51 1.14-1.14V5.29c0-.63-.51-1.14-1.14-1.14H5.29Z"
    })]
  }));
};
CRMDevelopmentIcon.displayName = 'CRMDevelopmentIcon';